<div *ngIf="isLoadingCounter > 0" class="center-container">
  <mat-spinner></mat-spinner>
</div>

<div class="page-container">
  <div class="flex items-center">
    <mat-form-field>
      <mat-label>Report</mat-label>
      <mat-select (selectionChange)="reportUnitSelected($event.source.value)" [formControl]="reportUnitFormControl">
        <mat-option *ngFor="let reportUnit of reportUnits" [value]="reportUnit.label">
          {{reportUnit.label}}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <mat-icon [matTooltip]="getInfoTooltip('Report')" class="info-icon">help_outline</mat-icon>
  </div>
  <div style="align-content: center">
    <div [innerHTML]="html"></div>
  </div>
</div>
